// extracted by mini-css-extract-plugin
export default {"header":"styles_header__c970C","title":"styles_title__el6TG","editText":"styles_editText__9I1Xv","close":"styles_close__gk9hm"};